import JWTDecode from 'jwt-decode';
import config from 'config';
import service from './authService';
import actions from './authActions';
import { AuthToken } from './authToken';
import { getHistory } from '../history';

export const OidcConfig = {
  client_id: 'dev-portal',
  grant_type: 'authorization_code',
  redirect_uri: config.url,
  scope: 'dev-portal',
  code_challenge_method: 'S256',
  response_type: 'code',
  redirect_endpoint: `${config.backendUrl}/oauth2/authorize`,
};

export const handleCompleteSignIn = async ({
  dispatch,
  accessToken,
  rememberMe,
  previousPath,
}) => {
  await AuthToken.set(accessToken, rememberMe);
  const currentUser = await service.fetchProfile();

  const decodedJWT = JWTDecode(accessToken);
  const { scope: scopes } = decodedJWT;

  window.analytics.track('userSigninSuccess', {});
  window.analytics.identify(currentUser.username);

  await dispatch({
    type: actions.AUTH_SUCCESS,
    payload: {
      currentUser,
      scopes,
    },
  });

  const redirectTo =
    previousPath && previousPath !== '/'
      ? `/?previousPath=${previousPath}`
      : '/';
  getHistory().push(redirectTo);
};
